/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { Button, Dropdown, FlexContainer, theme } from "@nordcloud/gnui";
import { useGetOrgUnitTypesV2Query } from "~/generated/graphql";
import { Fieldset, InputLoader } from "~/components";
import { AddOrgUnitTypeInlineForm } from "./AddOrgUnitTypeInlineForm";

type Props = {
  onSubmit: (newTypeId: string) => void;
  typeId: string;
};

export function SelectTypeForm({ typeId, onSubmit }: Props) {
  const [showSidebar, setShowSidebar] = useState(false);

  const { data, loading, refetch } = useGetOrgUnitTypesV2Query();

  const handleSubmit = (newTypeId: string) => {
    setShowSidebar(false);
    onSubmit(newTypeId);
    void refetch();
  };

  const types = data?.orgUnitTypesV2?.types ?? [];

  return (
    <div css={{ minWidth: "230px" }}>
      <InputLoader loading={loading}>
        <Fieldset css={{ marginBottom: 0 }}>
          <FlexContainer>
            <Dropdown
              name="Unit type"
              value={typeId}
              size="sm"
              options={types.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
              css={{
                "> div": {
                  maxHeight: "15rem",
                },
              }}
              onChange={handleSubmit}
            />
            <Button
              icon="plus"
              severity="low"
              ml={theme.spacing.spacing02}
              size="md"
              type="button"
              onClick={() => setShowSidebar(true)}
            />
          </FlexContainer>
        </Fieldset>
      </InputLoader>

      <AddOrgUnitTypeInlineForm
        isOpen={showSidebar}
        onClose={() => setShowSidebar(false)}
        onAdd={handleSubmit}
      />
    </div>
  );
}
